// Announcements / "What's new" — admin-authored release notes, dev patches, and notices.
// A published announcement pops up once per user on their next sign-in. Worker validates,
// SPA reuses the same schema for the authoring form.
import { z } from 'zod';
export const ANNOUNCEMENT_TAGS = ['update', 'feature', 'fix', 'notice'];
/** an announcement's details can be this long (the pop-up scrolls); the editor counts toward it */
export const ANNOUNCEMENT_BODY_MAX = 20000;
export const AnnouncementInputSchema = z.object({
    id: z.number().int().positive().optional(), // present = edit an existing announcement
    title: z.string().min(1).max(160),
    body: z.string().max(ANNOUNCEMENT_BODY_MAX, `The details can be up to ${ANNOUNCEMENT_BODY_MAX.toLocaleString('en-GB')} characters`).optional().default(''),
    tag: z.enum(ANNOUNCEMENT_TAGS).optional().default('update'),
    version: z.string().max(40).optional().default(''), // optional release label
    published: z.boolean().optional().default(false), // live = pops up on login
    // optional ISO datetime; when set and in the future the announcement auto-publishes at that time
    // (kept as a draft until then). Empty = no schedule.
    publishAt: z.string().max(40).optional().default(''),
});
export const AnnouncementIdSchema = z.object({ id: z.number().int().positive() });
//# sourceMappingURL=announcements.js.map